<!--
作者：小明哥
组件：首页banner
框架：VUE、vue-router、vuex、axios、ElementUI等
脚手架：VUE CLI3
-->
<template>
    <div>
        <el-carousel height="400px">
            <!--横幅banner-->
            <el-carousel-item v-for="(item,index) in bannerList" :key="index">
                <div class="niudao-banner menu-margin-top" :style="{
                                              background: 'url('+imgUrl(item.pathResourceName)+') no-repeat',
                                              backgroundPositionX:item.positionX+'px',
                                              backgroundPositionY:item.positionY+'px'
                                            }">
                    <div v-html="item.description"></div>
                </div>
            </el-carousel-item>
        </el-carousel>
    </div>
</template>
<script>
    export default {
        name: "HomeBanner",
        data(){
            return{
                //web查询用：web/webBanner/web
                //移动端查询用：web/webBanner/app
                url : "/web/webBanner/web",
                //banner list
                bannerList:[],
            }
        },
        created() {
            this.init();
        },
        methods:{
            init(){
                this.comm.getBaseListApi(this.url,rs => this.bannerList = rs);
            },
            imgUrl(value) {
                return this.config.baseImgUrl + value;
            }
        }
    }
</script>
<style scoped>

</style>
